export default __webpack_public_path__ + "static/arm_mbedstudio-ss-min-a8fd7c751f510d9d3c7fd0134167d60a.png";